import React from 'react'

import { B1, H5, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import Close from '@zet/design-system/svg/Close'

const Header = ({
  title,
  closeBottomSheet,
  subTitle,
}: {
  title: string
  closeBottomSheet: () => void
  subTitle?: string
}) => {
  return (
    <XStack className="border-grays-30 flex items-center justify-between border-b px-3 py-2">
      <Stack className="flex-auto">
        <H5>{title}</H5>
        <B1 className="text-grays-70 my-2">{subTitle}</B1>
      </Stack>
      <Pressable onPress={closeBottomSheet}>
        <Close />
      </Pressable>
    </XStack>
  )
}

export { Header }
